import { render, staticRenderFns } from "./FamilyLine.vue?vue&type=template&id=8ddbe6f6&"
import script from "./FamilyLine.vue?vue&type=script&lang=js&"
export * from "./FamilyLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports